import { z } from "zod";
import { CheckResultSchema } from "./quality-gate-result.js";
export const AccessibilityExceptionV1Schema = z
    .object({
    exceptionId: z.string().min(1),
    ruleId: z.string().min(1),
    reason: z.string().min(1),
    authorizedBy: z.string().min(1).optional(),
})
    .strict();
export const AccessibilityQualityPackV1Schema = z
    .object({
    schemaVersion: z.literal("accessibility-quality-pack.v1.0"),
    automatedBaseline: z.object({
        engine: z.literal("axe-heuristic-v1"),
        rulesEvaluated: z.number().int().nonnegative(),
        violations: z.number().int().nonnegative(),
    }),
    humanAttestation: z.object({
        status: z.enum(["PENDING", "RECORDED"]),
        attestedAt: z.string().datetime().optional(),
        attestedBy: z.string().min(1).optional(),
    }),
    exceptions: z.array(AccessibilityExceptionV1Schema).default([]),
    checks: z.array(CheckResultSchema),
})
    .strict();
export const PerformanceQualityPackV1Schema = z
    .object({
    schemaVersion: z.literal("performance-quality-pack.v1.0"),
    thresholdSetId: z.string().min(1),
    measurements: z.array(z
        .object({
        metricId: z.string().min(1),
        value: z.number(),
        unit: z.string().min(1),
        passed: z.boolean(),
    })
        .strict()),
    authorizedException: z
        .object({
        exceptionId: z.string().min(1),
        reason: z.string().min(1),
        authorizedBy: z.string().min(1),
    })
        .optional(),
    checks: z.array(CheckResultSchema),
})
    .strict();
export const SearchReadinessQualityPackV1Schema = z
    .object({
    schemaVersion: z.literal("search-readiness-quality-pack.v1.0"),
    rankingDisclaimerAcknowledged: z.literal(true),
    checks: z.array(CheckResultSchema),
})
    .strict();
export const PrivacyComplianceDimensionSchema = z.enum([
    "client_safe_artifacts",
    "privacy_policy_link",
    "cookie_consent_signal",
    "pii_surface_scan",
]);
export const PrivacyComplianceQualityPackV1Schema = z
    .object({
    schemaVersion: z.literal("privacy-compliance-quality-pack.v1.0"),
    dimensions: z.array(PrivacyComplianceDimensionSchema).min(1),
    checks: z.array(CheckResultSchema),
})
    .strict();
export const RESPONSIVE_VIEWPORT_PROFILES = [
    { viewportId: "mobile", widthPx: 390, label: "mobile" },
    { viewportId: "tablet", widthPx: 768, label: "tablet" },
    { viewportId: "desktop", widthPx: 1440, label: "desktop" },
];
//# sourceMappingURL=quality-gate-product-packs.js.map